export default "__VITE_ASSET__DBPG7Xdn__"